var map = {
	"./img-placeholder.svg": 51051,
	"./ingressinho-massacote-todos.svg": 17813,
	"./ingressinho-rejected.svg": 33852,
	"./ingressinho-sazonal.svg": 22504,
	"./ingressinho.svg": 93336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69621;